import React from "react"
// import {Link} from "react-router-dom"

import Logo from "../Logo/Logo"

import "./header.scss"

/**
 * App header
 * @component
 * @example
 * return <Header/>
 */

const Header = () => {
  return (
    <header className="headerContainer">
      <div className="headerLogoContainer">
        <div className="logo-link">
          <Logo />
        </div>
        {/* <Link to="/" className="logo-link">
          
        </Link> */}
      </div>
    </header>
  )
}

export default Header
